import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DebtList from './pages/Home';
import PaidDebts from './pages/PaidDebts';
import BottomNav from './components/BottomNav';
import Login from './pages/Login';
import Register from './pages/Register';

const isAuthenticated = () => !!localStorage.getItem('token');

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/lunas" element={isAuthenticated() ? <PaidDebts /> : <Navigate to="/login" />} />
        <Route path="/" element={isAuthenticated() ? <DebtList /> : <Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>
      <BottomNav />
    </Router>
  );
}

export default App;
